import unavailableImg from '../../assets/images/cloudSlashIcon.png'
import { Nav } from 'react-bootstrap'
import styles from './index.module.scss'
import { FormattedMessage } from 'react-intl'

interface ContentUnavailableProps {
    link: string
    linkDisplayNameId: string
    textMessageId: string
}

export const ContentUnavailable = (props: ContentUnavailableProps) => {
    const { link, linkDisplayNameId, textMessageId } = props

    return (
        <div className="w-100 h-100 pb-4 d-flex flex-column gap-4 justify-content-center align-items-center">
            <img
                src={unavailableImg}
                alt="news unavailable image"
            />
            <FormattedMessage id={textMessageId} />
            <Nav.Link
                className={`${styles.link} text-decoration-none p-0`}
                href={link}
                target="_blank"
                rel="noreferrer"
            >
                <FormattedMessage id={linkDisplayNameId} />
            </Nav.Link>
        </div>
    )
}
